import React from "react";
import { Copy, Link2, Share2 } from "lucide-react";

export default function ClassShareFooter({ onWhatsApp, onCopyLink, onCopyShareText }) {
  return (
    <footer
      className="max-w-page mx-auto px-4 mt-10 pt-6 border-t border-black/[0.08]"
      data-testid="class-dash-share-footer"
      aria-label="Share class"
    >
      <p className="font-ui text-[12px] font-medium text-ink/50 mb-3">Share</p>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <button
          type="button"
          onClick={onWhatsApp}
          className="inline-flex items-center gap-1.5 min-h-[44px] font-ui text-[13px] font-medium text-ink/70 hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-plum"
          data-testid="class-dash-share-whatsapp"
        >
          <Share2 className="w-3.5 h-3.5" strokeWidth={2.5} aria-hidden />
          Share on WhatsApp
        </button>
        <button
          type="button"
          onClick={onCopyLink}
          className="inline-flex items-center gap-1.5 min-h-[44px] font-ui text-[13px] font-medium text-ink/70 hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-plum"
          data-testid="class-dash-copy-link"
        >
          <Link2 className="w-3.5 h-3.5" strokeWidth={2.5} aria-hidden />
          Copy Link
        </button>
        <button
          type="button"
          onClick={onCopyShareText}
          className="inline-flex items-center gap-1.5 min-h-[44px] font-ui text-[13px] font-medium text-ink/70 hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-plum"
          data-testid="class-dash-copy-share-text"
        >
          <Copy className="w-3.5 h-3.5" strokeWidth={2.5} aria-hidden />
          Copy Share Text
        </button>
      </div>
    </footer>
  );
}
